export default "__VITE_ASSET__DrNhTU2Q__"